export default __webpack_public_path__ + "static/media/Lynette Lee Eng .97028106.jpg";